module.exports = __webpack_public_path__ + "static/Produktdesign-mobile-5f67a57e121b19d4813f3b6f6ec02a1b.gif";